import { useQuery } from '@tanstack/react-query';
import { ApiError, type RoleAssignmentsResponse } from '@citibox-panel/api-client';
import { retryUnlessRefused } from '@/lib/queryClient';

// The one key for the list: the write invalidates it; on a permission refusal the host's handler
// drops it with everything but /me.
export const ROLE_ASSIGNMENTS_KEY = ['role-assignments'] as const;

const isClientError = (error: unknown): boolean =>
  error instanceof ApiError && error.status >= 400 && error.status < 500;

// staleTime 0: another person of Sistemas may have changed the list, so every visit reads it again.
// networkMode 'always': offline is a failure with «Reintentar», never a paused, endless loading.
// A 4xx is the server's answer and is not asked again, a refusal least of all; a network failure or
// a 5xx gets one more try, by the same rule every other read follows.
export function useRoleAssignments(fetchRoleAssignments: () => Promise<RoleAssignmentsResponse>) {
  return useQuery({
    queryKey: ROLE_ASSIGNMENTS_KEY,
    queryFn: () => fetchRoleAssignments(),
    staleTime: 0,
    networkMode: 'always',
    retry: (failureCount, error) =>
      !isClientError(error) && retryUnlessRefused(failureCount, error),
  });
}
